<h1 class="u-sr-only">{{ 'Toolkit.Assessment.Preview.Title' | translate }}</h1>
<section class="c-section c-section--first c-section--last c-section--open c-section--static u-no-pb">
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell c-cell">
				<div class="c-card toolkit">
					<loader-overlay *ngIf="vm.loading"></loader-overlay>

					<div class="container container-narrow">
						<button class="btn-back" type="button" (click)="vm.close()">
							<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
							{{ 'Toolkit.Common.Back' | translate }}
						</button>

						<div class="toolkit__emptyPane" *ngIf="!vm.loading && vm.error">
							<div class="toolkit__emptyTitle">{{ 'Toolkit.Assessment.Preview.LoadError.Title' | translate }}</div>
							<div class="toolkit__emptyText">{{ 'Toolkit.Assessment.Preview.LoadError.Text' | translate }}</div>
						</div>

						<ng-container *ngIf="!vm.loading && !vm.error && vm.showEek2Results">
							<div *ngIf="vm.assignmentNote" class="exercise-therapist-note" style="margin-bottom:var(--tk-space-lg);">
								<div class="note-label">{{ 'Toolkit.Preview.FromTherapist' | translate }}</div>
								<p>{{ vm.assignmentNote }}</p>
							</div>

							<toolkit-eek2-therapist-results
								[assessment]="vm.assessment"
								[questions]="vm.rawQuestions || vm.questions"
								[assignment]="vm.assignment"
								[historyAssignments]="vm.assignmentHistory">
							</toolkit-eek2-therapist-results>
						</ng-container>

						<ng-container *ngIf="!vm.loading && !vm.error && vm.showSurveyResults && !vm.showEek2Results">
							<div *ngIf="vm.assignmentNote" class="exercise-therapist-note" style="margin-bottom:var(--tk-space-lg);">
								<div class="note-label">{{ 'Toolkit.Preview.FromTherapist' | translate }}</div>
								<p>{{ vm.assignmentNote }}</p>
							</div>

							<toolkit-survey-results
								[assessment]="vm.assessment"
								[questions]="vm.rawQuestions || vm.questions"
								[scoring]="vm.scoring"
								[assignment]="vm.assignment"
								[answers]="vm.answers"
								[audience]="vm.isPreview ? 'therapist' : 'client'">
							</toolkit-survey-results>
						</ng-container>

						<ng-container *ngIf="!vm.loading && !vm.error && !vm.showSurveyResults && vm.questions && vm.currentItem">

							<div *ngIf="vm.step === 0" class="exercise-header" style="margin-bottom:var(--tk-space-lg);">
								<div class="resource-meta" style="margin-bottom:var(--tk-space-sm);">
									<span class="resource-meta-item badge badge-blue">{{ 'Toolkit.Assessment.Common.Badge' | translate }}</span>
									<span class="resource-meta-item">{{ vm.questions.itemCount || vm.totalQuestions }} {{ 'Toolkit.Assessment.Common.Questions' | translate }}</span>
									<span class="resource-meta-item" *ngIf="vm.assessment?.durationMinutes != null || vm.assessment?.duration_minutes != null">
										{{ vm.assessment?.durationMinutes || vm.assessment?.duration_minutes }} {{ 'Toolkit.Common.Minutes' | translate }}
									</span>
								</div>
								<h1>{{ vm.assessment?.title || vm.questions.code }} — {{ vm.questions.fullTitle || '' }}</h1>
								<p class="text-muted mt-sm">{{ vm.assessment?.description || '' }}</p>
							</div>

							<div *ngIf="vm.assignmentNote" class="exercise-therapist-note" style="margin-bottom:var(--tk-space-lg);">
								<div class="note-label">{{ 'Toolkit.Preview.FromTherapist' | translate }}</div>
								<p>{{ vm.assignmentNote }}</p>
							</div>

							<div *ngIf="!vm.isPreview" class="card privacy-card" style="margin-bottom:var(--tk-space-lg);">
								<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#717680" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
								<p class="text-sm text-muted">{{ 'Toolkit.Assessment.Common.Privacy' | translate }}</p>
							</div>

							<div class="questionnaire-step">
								<div class="q-number">{{ 'Toolkit.Assessment.Common.Question' | translate }} {{ vm.step + 1 }} {{ 'Toolkit.Assessment.Common.Of' | translate }} {{ vm.totalQuestions }}</div>
								<div class="q-timeframe" *ngIf="vm.questions.timeframeText">{{ vm.questions.timeframeText }}</div>
								<div class="q-text">{{ vm.currentItem.text }}</div>
								<div class="q-options">
									<button
										type="button"
										class="q-option"
										[ngClass]="{ selected: vm.answers[vm.step] === opt.value }"
										(click)="vm.selectAnswer(opt.value)"
										[disabled]="vm.isReadOnly"
										*ngFor="let opt of vm.questions.responseScale">
										<span class="q-radio"></span>
										<span>{{ opt.label }}</span>
									</button>
								</div>
							</div>

							<div class="q-nav">
								<button class="btn-outline btn-sm" type="button" (click)="vm.prev()" [disabled]="vm.step === 0" [style.opacity]="vm.step === 0 ? 0.3 : 1">
									{{ 'Toolkit.Assessment.Common.Previous' | translate }}
								</button>
								<span class="text-sm text-muted">{{ vm.step + 1 }} / {{ vm.totalQuestions }}</span>

								<ng-container *ngIf="vm.step < vm.totalQuestions - 1">
									<button class="btn-primary btn-sm" type="button" (click)="vm.next()" [disabled]="vm.answers[vm.step] === undefined" [style.opacity]="vm.answers[vm.step] === undefined ? 0.5 : 1">
										{{ 'Toolkit.Assessment.Common.Next' | translate }}
									</button>
								</ng-container>
								<ng-container *ngIf="vm.step === vm.totalQuestions - 1">
									<button *ngIf="vm.isPreview" class="btn-outline btn-sm" type="button" (click)="vm.close()">
										{{ 'Toolkit.Assessment.Common.ClosePreview' | translate }}
									</button>
									<button *ngIf="!vm.isPreview" class="btn-primary btn-sm" type="button" (click)="vm.submit()" [disabled]="vm.answers[vm.step] === undefined || vm.submitting" [style.opacity]="vm.answers[vm.step] === undefined ? 0.5 : 1">
										{{ vm.submitting ? ('Toolkit.Common.Loading' | translate) : ('Toolkit.Assessment.Common.Submit' | translate) }}
									</button>
								</ng-container>
							</div>

							<div class="q-progress">
								<div class="q-progress-bar"><div class="q-progress-fill" [style.width.%]="progressPercent"></div></div>
								<div class="q-progress-text">{{ progressPercent | number:'1.0-0' }}% {{ 'Toolkit.Assessment.Common.Complete' | translate }}</div>
							</div>
						</ng-container>

						<div class="toolkit__emptyPane" *ngIf="!vm.loading && !vm.error && !vm.showSurveyResults && (!vm.questions || !vm.currentItem)">
							<div class="toolkit__emptyTitle">{{ 'Toolkit.Assessment.Preview.NoData.Title' | translate }}</div>
							<div class="toolkit__emptyText">{{ 'Toolkit.Assessment.Preview.NoData.Text' | translate }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
